var map = {
	"./wp-accordion/wp-accordion-content.js": 1768,
	"./wp-accordion/wp-accordion-heading.js": 8107,
	"./wp-accordion/wp-accordion.js": 7280,
	"./wp-animated-icon/wp-animated-icon.js": 8374,
	"./wp-background-video/wp-background-video.js": 3653,
	"./wp-carousel/wp-carousel.js": 918,
	"./wp-expand/wp-expand.js": 2958,
	"./wp-header/wp-header.js": 2150,
	"./wp-icon/wp-icon.js": 5486,
	"./wp-img/wp-img.js": 930,
	"./wp-map/wp-map-marker.js": 8139,
	"./wp-map/wp-map-static.js": 9763,
	"./wp-map/wp-map-styles.js": 7911,
	"./wp-map/wp-map.js": 6453,
	"./wp-nav-item/wp-nav-item.js": 7042,
	"./wp-nav/wp-nav.js": 806,
	"./wp-pattern-grid/wp-pattern-grid.js": 8249,
	"./wp-search/wp-search-results.js": 5972,
	"./wp-search/wp-search.js": 4178,
	"./wp-shape/wp-shape.js": 8526,
	"./wp-subscribe/wp-subscribe.js": 1164,
	"./wp-tabs/wp-tab.js": 7251,
	"./wp-tabs/wp-tabpanel.js": 8733,
	"./wp-tabs/wp-tabs.js": 9382,
	"./wp-video/wp-modal.js": 2812,
	"./wp-video/wp-video.js": 8894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2337;